import type { RcScopeType } from './shipments-types.js';

export const SHIPMENT_RANGE_OPERATIONAL_DAY_START_LOCAL_TIME = '05:00' as const;

export const recommendShipmentRangeStatusValues = [
  'recommended',
  'no_available_material',
  'closed_business_day_unavailable',
  'blocked_by_time_settings',
] as const;
export type RecommendShipmentRangeStatus = (typeof recommendShipmentRangeStatusValues)[number];

export const recommendShipmentRangeStartReasonValues = [
  'full_business_day',
  'after_previous_shipment_cutoff',
] as const;
export type RecommendShipmentRangeStartReason =
  (typeof recommendShipmentRangeStartReasonValues)[number];

export const recommendShipmentRangeEndReasonValues = [
  'last_fully_closed_store_business_day',
] as const;
export type RecommendShipmentRangeEndReason =
  (typeof recommendShipmentRangeEndReasonValues)[number];

export const recommendShipmentRangeUnavailableReasonValues = [
  'time_settings_requires_admin_action',
  'time_zone_unavailable',
  'session_time_zone_mismatch',
  'no_closed_business_day',
  'no_available_material',
] as const;
export type RecommendShipmentRangeUnavailableReason =
  (typeof recommendShipmentRangeUnavailableReasonValues)[number];

export interface RecommendShipmentRangeRequest {
  companyId: string;
  stationId: string;
  storeId?: string;
  locationId?: string;
  materialId: string;
  shipmentId?: string;
}

export interface RecommendShipmentRangeResponse {
  status: RecommendShipmentRangeStatus;
  rcScopeType: RcScopeType;
  rcScopeId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  timeZone: string | null;
  operationalDayStartLocalTime: typeof SHIPMENT_RANGE_OPERATIONAL_DAY_START_LOCAL_TIME;
  recommendedStartAt: string | null;
  recommendedEndAt: string | null;
  startReason: RecommendShipmentRangeStartReason | null;
  endReason: RecommendShipmentRangeEndReason | null;
  oldestAvailableOccurredAt: string | null;
  previousCutoffAt: string | null;
  lastClosedBusinessDate: string | null;
  lastClosedAt: string | null;
  includeTodayEndAt: string | null;
  unavailableReason?: RecommendShipmentRangeUnavailableReason;
}
